import LmsTable from "../ui/LmsTable";
import {
  useParseRouteActions,
  useFetchData,
} from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { LmsEndpoints } from "../../constants/LmsEndpoints";

const LmsCommentSubjectTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return (
    <LmsTable
      actionButtons={actionsButtons}
      apiSuffix = "/menu/comment-subject" 
    />
  );
};

const addCommentSubjectFields = (myForm) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Comment Category", LmsEndpoints.Metadata.GET.LIST_COMMENT_CATEGORIES, { required: true }),
    myForm.getInputField("Name", { required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getCheckboxField("Is Active", { inline: true }),
    myForm.getCheckboxField("Show To Non Loan Company", { inline: true }),
  ]);

  myForm.addCenteredGroup([myForm.getTextareaField("Description")]);
  return myForm;
};

const AddCommentSubjectForm = () => {
  const myForm = addCommentSubjectFields(new BCFormController({ isActive: true }, { submitSuffix: "menu/comment-subject" }));
  return <LmsFormGenerator myForm={myForm} />;
};

const EditCommentSubjectForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`menu/comment-subject/${id}`);
  const myForm = addCommentSubjectFields(new BCFormController(data, { submitSuffix: "menu/comment-subject" }));
  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const LmsNewMenusCommentSubject = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
      {isMainPage && <LmsCommentSubjectTable />}
      {isAdd && <AddCommentSubjectForm />}
      {isEdit && <EditCommentSubjectForm id={id} />}
    </>
  );
};

export default LmsNewMenusCommentSubject;
